import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import i18n from 'i18n'
import {useAuth} from 'app/modules/auth'

const InactiveUser = ({modelType}) => {
  const {t} = useTranslation()
  const {currentUser} = useAuth()

  return (
    <>
      <div
        className='modal show'
        style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}
        tabIndex={-1}
      >
        <div className='modal-dialog modal-lg modal-dialog-centered'>
          <div className='modal-content border-0 shadow-lg rounded-4 overflow-hidden'>
            {/* Header */}
            <div className='modal-header bg-primary text-white py-4 px-4 border-0'>
              <h5 className='modal-title fw-bold mb-0 text-white'>
                {i18n.language === 'fr' ? 'Chère étudiante, cher étudiant,' : 'Dear Student,'}
              </h5>
            </div>

            {/* Body */}
            <div
              className='modal-body px-5 py-5'
              style={{
                backgroundColor: '#f8f9fa',
                lineHeight: '1.9',
                fontSize: '15px',
              }}
            >
              <div className='bg-white p-4 rounded-3 shadow-sm'>
                {i18n.language === 'fr' ? (
                  <>
                    <p>
                      Nous vous informons que l’accès à votre espace académique est temporairement
                      suspendu.
                    </p>

                    <p>
                      Nous vous invitons à prendre contact avec l’Administration afin de procéder
                      aux vérifications nécessaires :
                    </p>
                    {currentUser?.campus_id === 17 && (
                      <div className='text-center my-3'>
                        <strong className='text-primary fs-5'>scolarite@swiss-umef.sn</strong>
                      </div>
                    )}

                    <p>Nous vous remercions de votre compréhension.</p>

                    <br />

                    <p className='mb-0'>
                      <strong>Cordialement,</strong>
                      <br />
                      La Direction
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      Please be informed that access to your academic portal has been temporarily
                      suspended.
                    </p>

                    <p>
                      Kindly contact the Administration so that the necessary checks can be
                      completed:
                    </p>
                    {currentUser?.campus_id == 17 && (
                      <div className='text-center my-3'>
                        <strong className='text-primary fs-5'>scolarite@swiss-umef.sn</strong>
                      </div>
                    )}
                    <p>Thank you for your understanding.</p>

                    <br />

                    <p className='mb-0'>
                      <strong>Yours sincerely,</strong>
                      <br />
                      The Management
                    </p>
                  </>
                )}
              </div>
            </div>
            {currentUser?.campus_id === 17 && (
              <div className='modal-footer bg-light border-0 justify-content-center py-3'>
                <small className='text-muted'>SWISS UMEF University – Dakar Campus</small>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default InactiveUser
